import './components/css/App.css';
import { Route, Routes, BrowserRouter, useLocation } from 'react-router-dom';
import MemorialNotFound from './components/container/MemorialNotFound';
import Memorial from './components/container/Memorial';
import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Component to handle redirect & routes
function AppRoutes() {
  const location = useLocation();

  useEffect(() => {
    // Store last dynamic code
    const pathParts = location.pathname.split('/');
    if (pathParts[1]) {
      localStorage.setItem('lastMemoCode', pathParts[1]);
    }

    // Redirect PWA launch (start_url = "/") to last slug
    if (window.location.pathname === '/') {
      const lastSlug = localStorage.getItem('lastMemoCode');
      if (lastSlug) {
        window.location.replace(`/${lastSlug}`);
      }
    }
  }, [location.pathname]);

  return (
    <Routes>
      <Route path='/' element={<MemorialNotFound />} />
      <Route path='/:slug' element={<Memorial />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <ToastContainer position='bottom-right' />
    </BrowserRouter>
  );
}

export default App;
